import { render, staticRenderFns } from "./Provinsi.vue?vue&type=template&id=3fcfd0fe&"
import script from "./Provinsi.vue?vue&type=script&lang=js&"
export * from "./Provinsi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports